import { PlanType } from '@enums/PlanType';
import { User } from 'types/User';

export const DEFAULT_ROUND_ROBIN_SLUG = 'fair-square-medicare/talk-to-an-expert';
export const DEFAULT_AGENT_SLUG = '30min';
const AEP_AGENT_SLUGS = {
  MAPD: 'aep-2027-mapd-consultation',
  PDP: 'd/ckk6-mhn-tjf',
  MEDIGAP: 'd/ckk6-mhn-tjf',
  TERMINATED: '2027-terminated-plan-consultation',
};

export const AEP_ROUND_ROBIN_SLUGS = {
  MAPD: 'fair-square-medicare/aep-mapd-consultation-2027',
  PDP: 'd/ckk6-mhn-tjf',
  MEDIGAP: 'd/ckk6-mhn-tjf',
  TERMINATED: 'fair-square-medicare/2027-terminated-plan-consultation',
};

type Args = {
  agent?: User;
  planType?: PlanType;
  isAEP?: boolean;
  forceRoundRobin?: boolean | null;
  isTerminatedUser?: boolean | null;
};

export default function getCalendlySlugForUser({
  agent,
  planType,
  isAEP,
  forceRoundRobin,
  isTerminatedUser = false,
}: Args) {
  const agentSlug = agent?.agent_profile?.scheduling_system_slug;
  if (isTerminatedUser) {
    return agentSlug ? `${agentSlug}/${AEP_AGENT_SLUGS.TERMINATED}` : AEP_ROUND_ROBIN_SLUGS.TERMINATED;
  }
  if (forceRoundRobin) {
    return isAEP ? AEP_ROUND_ROBIN_SLUGS.MAPD : DEFAULT_ROUND_ROBIN_SLUG;
  }
  if (isAEP) {
    if (planType === PlanType.PDP || planType === PlanType.MEDIGAP) {
      return AEP_ROUND_ROBIN_SLUGS.PDP;
    }

    return agentSlug
      ? `${agentSlug}/${AEP_AGENT_SLUGS[planType] || AEP_AGENT_SLUGS.MAPD}`
      : AEP_ROUND_ROBIN_SLUGS[planType] || AEP_ROUND_ROBIN_SLUGS.MAPD;
  }

  return agentSlug ? `${agentSlug}/${DEFAULT_AGENT_SLUG}` : DEFAULT_ROUND_ROBIN_SLUG;
}
